export * from './ArrowShapeAUpIcon';
export * from './ArrowShapeAUpIcon16Light';
export * from './ArrowShapeAUpIcon16Regular';
export * from './ArrowShapeAUpIcon16Solid';
export * from './ArrowShapeAUpIcon20Light';
export * from './ArrowShapeAUpIcon20Regular';
export * from './ArrowShapeAUpIcon20Solid';
export * from './ArrowShapeAUpIcon24Regular';
export * from './ArrowShapeAUpIcon24Solid';
export * from './ArrowShapeAUpIcon32Regular';
export * from './ArrowShapeAUpIcon64Regular';
